import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useState} from 'react';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {useUpdatePatientMutation} from '../../redux/services/patientApi';
import CustomTextField from '../common/CustomTextField';

const handleSubmit = ({put, id, onClose, onSuccess}) => async value => {
  const req = await put({id: id, body: {referral_details: value}});
  if (req.data && !req.error) {
    if (onSuccess) onSuccess();
    onClose();
  }
};

const EditPatientLeadDialog = props => {
  const {isOpen, onClose} = props;
  const referralDetails = get(props, 'patient.referral_details') || '';
  const [value, setValue] = useState(referralDetails);
  const [put, response] = useUpdatePatientMutation();
  const onSubmit = handleSubmit({
    put,
    id: get(props, 'patient.id'),
    onClose,
    onSuccess: get(props, 'onSuccess'),
  });
  return (
    <Box>
      <Dialog
       open={isOpen}
       onClose={onClose}
       fullWidth={true}
       maxWidth='sm'
       aria-labelledby="alert-dialog-title"
       aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography variant='h1' padding={1}>
            Edit Referral Details
          </Typography>
          <Divider/>
          <Stack spacing={1} padding={1}>
            {get(response, 'error')
              ? <Alert severity='error'>
                There was an error processing your request. Please try again later.
              </Alert>
              : null
            }
            <CustomTextField
              type='textarea'
              multiline
              label='Referral Details'
              placeholder='Add notes here'
              defaultValue={referralDetails}
              rows={3}
              onChange={e => setValue(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          <Button onClick={() => onSubmit(value)}>Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

EditPatientLeadDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
}

export default EditPatientLeadDialog;
